'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelLineStateComponent = exports.parcelLineStateComponent = {
    template: require('./parcel-line-state.html'),
    bindings: {
        state: '<'
    },
    controllerAs: 'vm',
    controller: ["parcelService", function controller(parcelService) {
        'ngInject';

        var vm = this;
        vm.stateContext;
        vm.stateIcon;

        vm.$onInit = init;

        function init() {
            vm.stateContext = 'text-' + parcelService.getOrderStateContext(vm.state.code);
            vm.stateIcon = parcelService.getOrderStateIcon(vm.state.code);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-line-state.js
// module id = 879
// module chunks = 0